import { createContext } from 'react'

import { TTabsContext } from '@/types'

const TabsContext = createContext<TTabsContext | undefined>(undefined)
TabsContext.displayName = 'TabsContext'

export { TabsContext }
